import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ColumnType, Columns, ZoneActionOptions } from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: false,
  selector: 'workflow-finxone-table',
  templateUrl: './workflow-finxone-table.component.html',
  styleUrls: ['./workflow-finxone-table.component.scss'],
})
export class WorkflowFinxoneTableComponent implements OnInit, OnChanges {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() options = new EventEmitter<{ id: string; res: any }>();
  @Output() navigateToUrl = new EventEmitter<{ link: string; id: string }>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() pageChange = new EventEmitter<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() closeMenuPopPup = new EventEmitter<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() rowClicked: EventEmitter<any> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() openContextMenuEvent: EventEmitter<{ event: MouseEvent; rowData: any }> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() contextMenuClickEvent: EventEmitter<{ name: string; isEnabled: boolean; rowData: any }> =
    new EventEmitter();
  @Output() searchTextEmit = new EventEmitter<string>();
  @Output() actionClicked = new EventEmitter<{ actionType: string; rowData: any }>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() public entityData: any[] = [];
  @Input() public pageSize: number;
  @Input() public actionOptions: ZoneActionOptions[];
  @Input() public pageNumber: number;
  @Input() public totalListCount: number;
  @Input() public isShowMoreOption: boolean;
  @Input() public entityName: string;
  @Input() public isShowOption: boolean;
  @Input() public renderContentAsHtml: boolean;
  @Input() public columns: Columns[] = [];
  @Input() public heading: { title: string; subTitle: string };
  @Input() public showHeadingWithSearch = false;
  @Input() public wrapText = true;
  @Input() public lazyLoad = true;
  @Input() public globalFilterFields: string[] = [];
  @Input() public enableHoverEvent = false;
  @Input() public enableSearch = true;
  @Input() public pagingEnabled = true;
  @Input() public showTableActions = false;
  @Input() public searchBoxClass = 'w-100';
  @Input() menuItemList: { name: string; isEnabled: boolean }[];
  @Input() public tableActionsConfigurations: {
    type: 'button' | 'icon';
    actionType: string;
    buttonStyleClass?: string;
    buttonLabel?: string;
    icon?: string;
  }[];

  public emptyTableMsg = ' No Data Found';
  public viewPaginationOptions: string[] = ['5', '10', '20'];
  public searchPlaceHolder = 'Search keywords';
  public searchIcon = 'search';
  public currentPageReport: string;
  public searchText: string;
  public viewPaginationOptionValue: number[];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedRow: any;
  isContextMenuOpen: boolean;
  selectedIndex: number;
  contextMenuEvent: MouseEvent;

  public readonly ColumnType = ColumnType;

  constructor() {}

  ngOnInit() {
    this.viewPaginationOptionValue = this.viewPaginationOptions.map((option) => parseInt(option));
    // this.onLoadHandlerTemplate();
    this.currentPageReport = `Showing 0 to ${this.pageSize} of ${this.totalListCount} entries`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['totalListCount']) {
      this.updateCurrentPageReport({ first: 0, rows: this.pageSize });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public moreOption(id: string, res: any) {
    this.options.emit({ id, res });
  }

  public navigateTo(link: string, id: string) {
    this.navigateToUrl.emit({ link, id });
  }
  public closeMenu() {
    this.closeMenuPopPup.emit();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onPageChange(event: any) {
    this.pageChange.emit(event);
    this.updateCurrentPageReport(event);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public loadCustomers(event: any) {
    this.updateCurrentPageReport(event);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public updateCurrentPageReport(event: any) {
    const first = event.first + 1;
    const value = parseInt(event.first) + parseInt(event.rows);
    const last = Math.min(value, this.totalListCount);
    this.currentPageReport = `Showing ${first} to ${last} of ${this.totalListCount} entries`;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public searchValue(event: any) {
    this.searchText = event.target.value;
    this.searchTextEmit.emit(this.searchText);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick(rowData: any) {
    if (this.isContextMenuOpen) {
      this.isContextMenuOpen = false;
      return;
    }
    this.rowClicked.emit(rowData);
  }

  toggleColumnCheckbox(event: { checked: boolean; value: string }, rowData: any, rowKey: string) {
    rowData[rowKey] = event.checked;
    this.rowClicked.emit(rowData);
  }

  onChangeColumnText(event: any, rowData: any, rowKey: string) {
    rowData[rowKey] = event?.target?.value;
    this.rowClicked.emit(rowData);
  }

  onChangeDropdownValue(event: string, rowData: any, rowKey: string) {
    rowData[rowKey] = event;
    this.rowClicked.emit(rowData);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openContextMenu(event: MouseEvent, rowData: any, index: number) {
    this.contextMenuEvent = event;
    this.selectedRow = rowData;
    this.selectedIndex = index;
    this.isContextMenuOpen = true;
    this.openContextMenuEvent.emit({
      event: event,
      rowData,
    });
  }

  contextMenuClick(event: { name: string; isEnabled: boolean }) {
    this.contextMenuClickEvent.emit({ ...event, rowData: this.selectedRow });
  }

  resetContextMenuState() {
    this.isContextMenuOpen = false;
    this.selectedRow = {};
  }

  public handleActionClick(event: { actionType: string; rowData: any }) {
    this.actionClicked.emit(event);
  }
}
